'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FamilyGrid = require('./FamilyGrid.css');

var _FamilyGrid2 = _interopRequireDefault(_FamilyGrid);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import convert from '../../helpers/convert'

var FamilyGrid = (_dec = (0, _reactCssModules2.default)(_FamilyGrid2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FamilyGrid, _Component);

  function FamilyGrid(props) {
    (0, _classCallCheck3.default)(this, FamilyGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FamilyGrid.__proto__ || (0, _getPrototypeOf2.default)(FamilyGrid)).call(this, props));

    _this.onMouseEnter = function (prop) {
      return function () {
        // this.state.onHovers[prop] = true
        var onHovers = (0, _assign2.default)({}, _this.state.onHovers);
        onHovers[prop] = true;
        _this.setState({ onHovers: onHovers });
        // console.log('enter:',onHovers )
      };
    };

    _this.onMouseLeave = function (prop) {
      return function () {
        var onHovers = (0, _assign2.default)({}, _this.state.onHovers);
        delete onHovers[prop];
        _this.setState({ onHovers: onHovers });
        // console.log('leave:',onHovers )
        // console.log('leave:',this.state.onHovers )
      };
    };

    _this.renderCompanies = function () {
      return _config2.default.familyFunds.slice(0, _this.props.topN || _config2.default.familyFunds.length).map(function (c, idx) {
        return _this.renderCompany(idx, c.fund_family_name, c.ff_all_asset_sum, c.ff_all_weight_total, c.num_equity_funds, 4);
      });
    };

    _this.renderLogo = function (title) {
      var fileName = _format2.default.imgPath(title);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        // console.log('')
      }
      if (hasLogo) {
        return _react2.default.createElement('img', {
          styleName: 'box-title-logo',
          src: companyLogo,
          alt: title
        });
      } else {
        // console.log(fileName)
        return _react2.default.createElement(
          'span',
          null,
          title
        );
      }
    };

    _this.renderCompany = function (idx, title, asset, perc, numFunds, rating) {
      var safeName = encodeURIComponent(title);
      return _react2.default.createElement(
        'div',
        { key: idx, styleName: 'companies-box-wrap' },
        _react2.default.createElement(
          _components.Link,
          {
            onMouseEnter: _this.onMouseEnter('company-' + idx),
            onMouseLeave: _this.onMouseLeave('company-' + idx),
            log: _analytics2.default.eventToFamily(title),
            to: _config2.default.routes.families + '?q=' + safeName,
            styleName: 'companies-link',
            title: title
          },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-box-' + rating },
            _react2.default.createElement(
              'div',
              { styleName: 'box-title-wrapper' },
              _this.renderLogo(title)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              numFunds,
              ' equity funds analyzed'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              _react2.default.createElement(
                'strong',
                null,
                _format2.default.perc(perc, true)
              ),
              ' fossil fuel exposure'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              _react2.default.createElement(
                'strong',
                null,
                _format2.default.money(asset, true, 'US Dollar', false, 0)
              ),
              '\xA0 in fossil fuel stocks'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'learn-more-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'learn-more-' + rating },
                'More',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    };

    _this.renderAddtl = function () {
      if (!_this.props.fullGrid) {
        return null;
      }

      var allFams = _config2.default.formOptions.fundFamilyAll;
      var filteredFams = allFams.reduce(function (arr, el) {
        if (el.name !== 'All funds') {
          arr.push(el);
        }
        return arr;
      }, []);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'addtl-fam-info' },
          _react2.default.createElement(
            'strong',
            null,
            'We analyze funds from over one hundred asset managers. \xA0 See the full list below:'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'addtl-fam-links' },
          filteredFams.map(function (el, ix) {
            return _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.families + '?q=' + el.name,
                title: el.name,
                key: el.name,
                strong: true
              },
              _react2.default.createElement(
                'div',
                { styleName: 'addtl-fam-link' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'addtl-fam-link-logo' },
                  _this.renderLogo(el.name, el.name)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'addtl-fam-link-lbl' },
                  el.name,
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            );
          })
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(FamilyGrid, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'companies' },
        _react2.default.createElement('div', { styleName: 'companies-anchor', id: 'companies' }),
        _react2.default.createElement(
          'div',
          { styleName: 'companies-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-title' },
            'Fund managers have trillions of dollars invested in the stocks of fossil fuel companies'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-info' },
            _react2.default.createElement(
              'strong',
              null,
              'Major asset managers handle the retirement savings of millions of Americans.'
            ),
            '\xA0 Their mission is to help people save for the future - but they\'re directing trillions of dollars of capital to the carbon polluters maintaining and expanding the fossil fuel infrastructure that threatens our future.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-info' },
            _react2.default.createElement(
              'strong',
              null,
              'Are your savings invested with one of these financial giants?'
            ),
            '\xA0 Find out just how much they have invested in the top owners of carbon reserves, the largest coal-fired utilities, and other fossil fuel companies. Then, share to spread the word: business as usual is killing the climate.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-boxes' },
            this.renderCompanies()
          ),
          this.renderAddtl()
        )
      );
    }
  }]);
  return FamilyGrid;
}(_react.Component), _class2.propTypes = {
  fullGrid: _react.PropTypes.bool,
  topN: _react.PropTypes.number
}, _temp)) || _class);
exports.default = FamilyGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FamilyGrid/FamilyGrid.js
// module id = 1372
// module chunks = 0